<template>
  <div
    class="absolute inset-0 z-0 flex flex-col items-center transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
    <h1 class="mb-6 text-4xl font-medium text-slate-500">Welcome again</h1>
    <div
      class="bg-center w-[350px] h-[200px] bg-no-repeat bg-contain bg-[url('@/assets/images/logo-home.png')]"></div>
  </div>
</template>
<script setup lang="ts"></script>
